import { render, staticRenderFns } from "./addCountryData.vue?vue&type=template&id=018cb1b7&scoped=true&"
import script from "./addCountryData.vue?vue&type=script&lang=js&"
export * from "./addCountryData.vue?vue&type=script&lang=js&"
import style0 from "./addCountryData.vue?vue&type=style&index=0&id=018cb1b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018cb1b7",
  null
  
)

export default component.exports